export default {
  primaryColor: '#2875ea',
  primaryTextColor: '#FFFFFF',

  successColor: '#39B54A',
  dangerColor: '#F85359',
  warningColor: '#F7981C',
  infoColor: '#2875ea',

  disabledColor: '#E9EDF1',
  disabledTextColor: '#B0B0B1',
  disabledBorderColor: '#D1D4D8',

  labelTextColor: '#7F8FA4',
  labelTextSelectedColor: '#354052',

  whiteColor: '#FFFFFF',
  blueColor: '#2875ea',
  blueLightColor: '#F1F4F8',
  darkColor: '#273142',
  dark2Color: '#333F52',
  elementsBaseColor: '#E2E7EE',
  greenColor: '#39B54A',
  mintColor: '#09C199',
  grayColor: '#516173',
  grayLightColor: '#A8AAB7',
  iconColor: '#C5D0DE',
  orangeColor: '#F7981C',
  redColor: '#F85359',
  violetColor: '#6B47DB',

  whiteTextColor: '#FFFFFF',
  blueTextColor: '#2EA2F8',
  darkTextColor: '#354052',
  greenTextColor: '#39B54A',
  grayTextColor: '#7F8FA4',
  redTextColor: '#ED1C24',

  blackGradient: 'linear-gradient(-180deg, #516173 3%, #3B4857 98%)',
  blueGradient: 'linear-gradient(-1deg, #2875ea 2%, #2DA1F8 98%)',
  defaultGradient: 'linear-gradient(0deg, #F2F4F5 0%, #FFFFFF 100%)',
  greenGradient: 'linear-gradient(-180deg, #39B54A 0%, #34AA44 98%)',
  orangeGradient: 'linear-gradient(-180deg, #F7981C 2%, #F76B1C 100%)',
  redGradient: 'linear-gradient(-180deg, #F85359 3%, #DC151D 98%)',
  violetGradient: 'linear-gradient(-1deg, #6B47DB 2%, #8261E6 98%)',
  fusionGradient: 'linear-gradient(-152deg, #3023AE 6%, #C86DD7 100%)',
  turquoiseGradient: 'linear-gradient(-134deg, #6DD7C7 0%, #188E9B 100%)',
};
